<template>
  <v-app>
    <alert-modal v-if="getIsInAlert()"></alert-modal>
    <loader v-if="getLoader()"></loader>
    <v-main style="height: 100%;">
      <div style="height: 100%;">
        <router-view></router-view>
        <comment-event-modal v-if="getShowCommentEventModal()"></comment-event-modal>
      </div>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data: () => ({ drawer: true }),
  mounted() {
    this.buildDeviceId()
    if (this.getUserToken() === null ||
      this.getUserToken() === '' ||
      this.getUserToken() === undefined) {
      this.$router.push({ name: 'login' })
    }
  },
}
</script>

<style lang="scss">
@import './assets/stylesheets/application.scss';

html {
  overflow: auto!important;
}

header {
  left: 0 !important;
}
</style>
